import {ModalTiteledWindow} from "./modalWindow.js";
import {DataView} from '../dataview.js';

export class ModalDebugLog extends ModalTiteledWindow {

   constructor(app, dm) {
      super();
      this.dm = dm;
      this.buildHTML(app, dm);
   }

   async buildHTML(app, dm) {

      let html = `<div class="modal-debug-log">
                     <div class="left">
                        <div class="buttons"><button class="reload">re</button><button class="clear">del</button></div>
                        <div class="list"></div>
                     </div>
                     <div class="content">
                     </div>
                  </div>`;

      this.setTitle("Debug Log");
      this.setBody(html);

      this.panel.querySelector('button.clear').addEventListener('click', (e) => {
         this.dm.sinRequest({ action: 'debug-log-clear' }, false, false)
         .then(response => this.loadItems());         
      });

      this.panel.querySelector('button.reload').addEventListener('click', (e) => this.loadItems());         


      this.list = new DataView(this.panel.querySelector('.left .list'));
      this.listSettings = {
         columns: [
            {
               title: 'Ben.',
               data: 'user',
               sort: { index: 1, dir: 1 },
               css: { height: '1.5rem' }
            },
            {
               title: 'Datum',
               data: (item) => (new Date(item.timestamp*1000)).format("%d.%m.%Y<br>%H:%i:%s"),
               sort: { index: 2, dir: 0 }
            },
            {
               title: 'Typ',
               data: 'type',
               sort: { index: 3, dir: 1}
            }
         ],
         onSelected: (item) => {
            this.loadData(item.id);
         }         
      };



      let data = { test: "Hallo"};
      /*
      for (var i = 0; i < localStorage.length; i++){
         data[localStorage.key(i)] = localStorage.getItem(localStorage.key(i));
      }
      */

      db.tables.forEach(async (table) => {
         //data[table.name] = await db[table.name].toArray();
      });

      this.loadItems();

      setTimeout(() => {
         this.show();
      } , 100);

   }

   loadItems() {

      const elContent = this.panel.querySelector('.modal-debug-log .content');
      elContent.empty();

      this.dm.sinRequest({ action: 'debug-log-get-items' }, false, false)
      .then(response => {
         this.list.load(response.data, this.listSettings);
      });



   }

   loadData(id) {

      this.dm.sinRequest({ action: 'debug-log-get-data', id: id }, false, false)
      .then(response => {
         const elContent = this.panel.querySelector('.modal-debug-log .content');
         elContent.empty();

         const tree = JsonView.createTree(response.data);
         JsonView.render(tree, elContent);
      });

   }


}
